document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.image-backdrop')) {
        resizeImageBackdrop();
        window.addEventListener('resize', resizeImageBackdrop);
    }

    function resizeImageBackdrop() {
        document.querySelectorAll('.image-backdrop').forEach(function (backdrop) {
            const content = backdrop.querySelector('.js-getContentHeight');
            const target = backdrop.querySelector('.js-setImgHeight');

            if (content && target) {
                target.style.minHeight = '0px'; // reset first
                const overlayHeight = content.offsetHeight;
                const setHeight = overlayHeight + 60;
                target.style.minHeight = setHeight + 'px';
            }
        });
    }
});
